import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = 'empresas/contribuyentes-vinculados/';

/**
 * GET Contribuyente sVinculados
 * @param {Object} params
 * @returns {Promise<object[]>}
 */
export const getContribuyentesVinculados = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Contribuyente Vinculado
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getContribuyenteVinculado = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Contribuyente Vinculado
  * @param {object} values
  * @returns {Promise<object|boolean>}
 */
export const postContribuyenteVinculado = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values, {}, true));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Contribuyente Vinculado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchContribuyenteVinculado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values, {}, true));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Contribuyente Vinculado
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteContribuyenteVinculado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
